var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigure05Star01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_123_533)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6442 31.9133L11.3883 22.7238L0.376953 22.6038L7.06213 13.8871L3.64675 3.31671L14.0347 7.11784L22.9333 0.705078L22.6683 11.7745L31.5856 18.3786L21.0334 21.418L17.6442 31.9133Z",
    fill: "#60A6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.704 32.3335L11.2875 22.9114L0 22.7875L6.85688 13.8419L3.35938 3.00892L14.0049 6.9076L23.1424 0.333496L22.8662 11.6806L32.0112 18.4536L21.1865 21.568L17.704 32.3335ZM0.74653 22.4198L11.4816 22.5361L17.5845 31.478L20.9028 21.2641L31.1676 18.3035L22.478 11.8682L22.7393 1.08397L14.0646 7.32787L13.9713 7.2941L3.94168 3.6243L7.2712 13.9207L0.74653 22.4198Z",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9872 24.8662L13.3143 19.4703L6.84937 19.399L10.7761 14.2808L8.77168 8.07817L14.8671 10.3071L20.0928 6.54346L19.936 13.0425L25.1729 16.9187L18.9767 18.7011L16.9872 24.8662Z",
    fill: "#FEBDB9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.047 25.2865L13.2173 19.658L6.47241 19.5829L10.5783 14.2471L8.47311 7.77055L14.841 10.0895L20.2907 6.16455L20.1264 12.9413L25.5873 16.9938L19.1224 18.87L17.047 25.2865ZM7.22641 19.2152L13.4151 19.2828L16.9276 24.4422L18.8312 18.551L24.7549 16.8437L19.7494 13.1327L19.8988 6.91502L14.897 10.5173L9.0666 8.38594L10.9852 14.3184L7.22641 19.2152Z",
    fill: "#242424"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_123_533"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.333496)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigure05Star01);
export default __webpack_public_path__ + "static/media/figure_05_star_01.211d83813003e816a127cd3f9cbf8a38.svg";
export { ForwardRef as ReactComponent };